/** Namespace `teams` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const teams = {
  loadFailed: "Không đọc được danh sách đội ngũ.",
  loadDetailFailed: "Không đọc được chi tiết đội.",
  addFailed: "Không thêm được thành viên.",
  removeFailed: "Không gỡ được thành viên.",
  title: "Đội ngũ",
  introBefore: "Đội là đơn vị nhận trách nhiệm ở màn Quyền sở hữu. Một đội ",
  introStrong: "rỗng",
  introAfter: " làm dịch vụ trông như đã có chủ trong khi không ai nhận — tệ hơn cả không gán.",
  emptyTitle: "Chưa có đội ngũ nào.",
  emptyHint: "Tạo đội ở màn Quyền sở hữu, rồi quay lại đây để thêm thành viên.",
  empty: "rỗng",
  memberCountOne: "{count} người",
  memberCount: "{count} người",
  noMembersBefore: "Đội này ",
  noMembersStrong: "chưa có ai",
  noMembersAfter: ". Dịch vụ gán cho nó sẽ trông như đã có chủ trong khi không ai nhận trách nhiệm.",
  "col.member": "Thành viên",
  "col.teamRole": "Vai trong đội",
  "col.inHub": "Trong hub",
  active: "Đang hoạt động",
  leftHub: "Đã rời hub",
  remove: "Gỡ",
  addMember: "Thêm thành viên",
  pickPerson: "Chọn người…",
  activeOnly: "Chỉ người đang hoạt động trong hub.",
} as const;
